import { computed }           from 'mobx';
import InvoicePrivateApiModel from '../../abstracts/InvoicePrivateApiModel';

export default class BillableItemMetaModel extends InvoicePrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'billableItem': id;
		'billableItem.billable': id;
		'service': string;
		'reference': InvoiceBillableItemMetaReference;
		'value': string;
	}> = {};

	static get path(): string {
		return '/billable_item_metas/{?id}';
	}

	@computed
	public get reference(): InvoiceBillableItemMetaReference {
		return this.get('reference');
	}

	@computed
	public get service(): number {
		return this.get('service');
	}

	@computed
	public get value(): string {
		return this.get('value');
	}

	@computed
	public get billableItemId(): id {
		return this.get('billableItem.id');
	}

	public _sorts: ModelSortsExtended<{
		'id': string;
		'reference': string;
		'updatedAt': string;
		'value': string;
	}> = {};
}
